import React from "react";
import "../css/ParentEngagement.css";
import { Link } from "react-router-dom";
const ParentEngagement = () => {
  const parentImg = "./images/k.jpeg";

  return (
    <section className="parent-engagement-container">
      <div className="pe-main-card">
        <div className="pe-flex-layout">
          {}
          <div className="pe-info-box">
            <div className="pe-orange-header">
              <h2>Parent Engagement</h2>
            </div>

            <div className="pe-content-body">
              {}
              <p className="pe-desc-text">
                We believe that a strong partnership between parents and the
                school is vital for student success. Our engagement programs
                provide opportunities for parents to participate in school life,
                share their expertise, and stay informed about their child's
                progress and the school's initiatives.
              </p>

             <Link to="/parent-engagement" className="btn btn-primary">
  READ MORE <i>›</i>
</Link>
            </div>
          </div>

          {}
          <div className="pe-image-box">
            <img
              src={parentImg}
              alt="Parent Engagement Activity"
              className="pe-hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ParentEngagement;
